/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import { solicitarEdital } from 'store/modules/bidding_store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { BiddingState } from 'store/modules/bidding_store/types';
import { openSupportChat } from 'services/support_chat';

const SolicitarEdital = () => {
  const dispatch = useDispatch();
  const [biddingId, setBiddingId] = useState<number | string>('');
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);

  const { biddings } = useSelector<ApplicationState, BiddingState>(
    (state) => state.session.biddings,
  );

  const handleClick = () => {
    dispatch(solicitarEdital(biddingId));
  };

  useEffect(() => {
    if (biddings?.solicitation_edital_status) {
      setShowSuccessAlert(true);
      setTimeout(() => setShowSuccessAlert(false), 5000);
    } else if (biddings?.solicitation_edital_message) {
      setShowErrorAlert(true);
      setTimeout(() => setShowErrorAlert(false), 5000);
    }
  }, [biddings]);

  return (
    <div className="row p-3">
      <form>
        <label htmlFor="#">Nº Conlicitação</label>
        <div className="form-row mr-2">
          <div className="col-auto">
            <input
              id="id_licitacao"
              type="text"
              className="mr-2 form-control"
              onChange={(event) => setBiddingId(event.target.value)}
              value={biddingId}
            />
          </div>
          <div className="col-auto">
            <button
              type="button"
              className="btn btn-primary mb-2 mt-1 mt-md-0"
              onClick={handleClick}
            >
              Solicitar Edital
            </button>
          </div>
        </div>
      </form>

      {showSuccessAlert && (
        <div className="col-md-12 mt-3">
          <div className="alert alert-success m-0 text-center">
            <p>Recebemos sua solicitação!</p>
            <p>
              Estamos tentando contato com o órgão e assim que obtiver a resposta enviaremos no seu
              e-mail.
            </p>
            <p className="text-danger">
              Caso a resposta não chegue na caixa de entrada, verifique também a caixa de SPAM.
            </p>
          </div>
        </div>
      )}

      {showErrorAlert && (
        <div className="col-md-12 mt-3">
          <div className="alert alert-danger m-0 text-center">
            <p>{biddings?.solicitation_edital_message}</p>
            <button
              type="button"
              className="btn btn-link m-0 p-0 btn-block mt-2"
              onClick={() => {
                openSupportChat();
              }}
            >
              Falar com um consultor
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SolicitarEdital;
